import { useTranslation } from 'react-i18next';

import { useDeleteMessageMutation } from '../hooks/useMessageMutation';
import ModalConfirmation from '../../../../../shared/ModalConfirmation/ModalConfirmation.jsx';
import { Modal } from '../../../../boardSetup/components/Modals/Modal.jsx';
import { useNotification } from '../../../../../shared/Notification/useNotification';

export const DeleteMessageModal = ({
  open,
  setOpen,
  messageId,
  postId,
  campaignId,
  reminderDate,
}) => {
  const { deleteMessageMutation } = useDeleteMessageMutation();
  const { t } = useTranslation('messages');
  const { showSuccess } = useNotification();

  const body = reminderDate
    ? t('deleteModal.body')
    : t('deleteModal.bodyNoReminder');

  const onSave = () => {
    deleteMessageMutation(
      { messageId, postId, campaignId },
      {
        onSuccess: () => {
          showSuccess({ content: 'Notification Deleted Successfully' });
        },
      },
    );
    setOpen(false);
  };

  return (
    <Modal open={open} onClose={() => setOpen(false)}>
      <ModalConfirmation
        variant="error"
        onSave={onSave}
        onCancel={() => setOpen(false)}
        header={t('deleteModal.title')}
        body={body}
        cancelText={t('deleteModal.cancel')}
        submitText={t('deleteModal.delete')}
      />
    </Modal>
  );
};
